import classNames from 'classnames';
import { Card, CardContent, ICardProps } from 'shared-components';
import styles from './fact.module.css';

export interface IFactProps extends ICardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
  percChange?: number;
}

export const Fact: React.FC<IFactProps> = ({
  icon,
  value,
  title,
  percChange,
}) => {
  return (
    <Card>
      <CardContent>
        <div className={styles.fact__icon}>{icon}</div>
        <div className={styles.fact__value}>{value}</div>
        <div className={styles.fact__title}>{title}</div>
        {percChange && (
          <div
            className={classNames(styles.fact__change, {
              [styles['fact__change--positive']]: percChange > 0,
              [styles['fact__change--negative']]: percChange < 0,
            })}
          >
            {Math.abs(percChange)}%
          </div>
        )}
      </CardContent>
    </Card>
  );
};
